"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/order/v1/cms_common.proto (package spwn.order.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.CMSOrderFulfillmentDestination = exports.CMSOrderSalesBreakdownItem = exports.CMSOrderLineItemGoodsSelfShipping = exports.CMSOrderLineItemGoodsDigital = exports.CMSOrderLineItemGoods = exports.CMSOrderShippingSelf = exports.CMSOrderShipping = exports.CMSOrderGoods = exports.CMSBankAccount = exports.CMSOrderPaymentMethod = exports.CMSOrderGoodsStatus = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * @generated from enum spwn.order.v1.CMSOrderGoodsStatus
 */
var CMSOrderGoodsStatus;
(function (CMSOrderGoodsStatus) {
    /**
     * @generated from enum value: CMS_ORDER_GOODS_STATUS_UNSPECIFIED = 0;
     */
    CMSOrderGoodsStatus[CMSOrderGoodsStatus["CMS_ORDER_GOODS_STATUS_UNSPECIFIED"] = 0] = "CMS_ORDER_GOODS_STATUS_UNSPECIFIED";
    /**
     * 支払い待ち
     *
     * @generated from enum value: CMS_ORDER_GOODS_STATUS_PAYMENT_PENDING = 1;
     */
    CMSOrderGoodsStatus[CMSOrderGoodsStatus["CMS_ORDER_GOODS_STATUS_PAYMENT_PENDING"] = 1] = "CMS_ORDER_GOODS_STATUS_PAYMENT_PENDING";
    /**
     * 支払い前のキャンセル
     *
     * @generated from enum value: CMS_ORDER_GOODS_STATUS_CANCELED_BEFORE_PAYMENT = 2;
     */
    CMSOrderGoodsStatus[CMSOrderGoodsStatus["CMS_ORDER_GOODS_STATUS_CANCELED_BEFORE_PAYMENT"] = 2] = "CMS_ORDER_GOODS_STATUS_CANCELED_BEFORE_PAYMENT";
    /**
     * 支払い済み
     *
     * @generated from enum value: CMS_ORDER_GOODS_STATUS_PAID = 3;
     */
    CMSOrderGoodsStatus[CMSOrderGoodsStatus["CMS_ORDER_GOODS_STATUS_PAID"] = 3] = "CMS_ORDER_GOODS_STATUS_PAID";
    /**
     * 発送済み
     *
     * @generated from enum value: CMS_ORDER_GOODS_STATUS_SHIPPED = 4;
     */
    CMSOrderGoodsStatus[CMSOrderGoodsStatus["CMS_ORDER_GOODS_STATUS_SHIPPED"] = 4] = "CMS_ORDER_GOODS_STATUS_SHIPPED";
    /**
     * 返金済み（キャンセル）
     *
     * @generated from enum value: CMS_ORDER_GOODS_STATUS_REFUNDED = 5;
     */
    CMSOrderGoodsStatus[CMSOrderGoodsStatus["CMS_ORDER_GOODS_STATUS_REFUNDED"] = 5] = "CMS_ORDER_GOODS_STATUS_REFUNDED";
})(CMSOrderGoodsStatus = exports.CMSOrderGoodsStatus || (exports.CMSOrderGoodsStatus = {}));
// Retrieve enum metadata with: proto3.getEnumType(CMSOrderGoodsStatus)
protobuf_1.proto3.util.setEnumType(CMSOrderGoodsStatus, "spwn.order.v1.CMSOrderGoodsStatus", [
    { no: 0, name: "CMS_ORDER_GOODS_STATUS_UNSPECIFIED" },
    { no: 1, name: "CMS_ORDER_GOODS_STATUS_PAYMENT_PENDING" },
    { no: 2, name: "CMS_ORDER_GOODS_STATUS_CANCELED_BEFORE_PAYMENT" },
    { no: 3, name: "CMS_ORDER_GOODS_STATUS_PAID" },
    { no: 4, name: "CMS_ORDER_GOODS_STATUS_SHIPPED" },
    { no: 5, name: "CMS_ORDER_GOODS_STATUS_REFUNDED" },
]);
/**
 * @generated from enum spwn.order.v1.CMSOrderPaymentMethod
 */
var CMSOrderPaymentMethod;
(function (CMSOrderPaymentMethod) {
    /**
     * @generated from enum value: CMS_ORDER_PAYMENT_METHOD_UNSPECIFIED = 0;
     */
    CMSOrderPaymentMethod[CMSOrderPaymentMethod["CMS_ORDER_PAYMENT_METHOD_UNSPECIFIED"] = 0] = "CMS_ORDER_PAYMENT_METHOD_UNSPECIFIED";
    /**
     * クレジットカード
     *
     * @generated from enum value: CMS_ORDER_PAYMENT_METHOD_CARD = 1;
     */
    CMSOrderPaymentMethod[CMSOrderPaymentMethod["CMS_ORDER_PAYMENT_METHOD_CARD"] = 1] = "CMS_ORDER_PAYMENT_METHOD_CARD";
    /**
     * コンビニ
     *
     * @generated from enum value: CMS_ORDER_PAYMENT_METHOD_KONBINI = 2;
     */
    CMSOrderPaymentMethod[CMSOrderPaymentMethod["CMS_ORDER_PAYMENT_METHOD_KONBINI"] = 2] = "CMS_ORDER_PAYMENT_METHOD_KONBINI";
})(CMSOrderPaymentMethod = exports.CMSOrderPaymentMethod || (exports.CMSOrderPaymentMethod = {}));
// Retrieve enum metadata with: proto3.getEnumType(CMSOrderPaymentMethod)
protobuf_1.proto3.util.setEnumType(CMSOrderPaymentMethod, "spwn.order.v1.CMSOrderPaymentMethod", [
    { no: 0, name: "CMS_ORDER_PAYMENT_METHOD_UNSPECIFIED" },
    { no: 1, name: "CMS_ORDER_PAYMENT_METHOD_CARD" },
    { no: 2, name: "CMS_ORDER_PAYMENT_METHOD_KONBINI" },
]);
/**
 * @generated from message spwn.order.v1.CMSBankAccount
 */
class CMSBankAccount extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 銀行名
         *
         * @generated from field: string bank_name = 1;
         */
        this.bankName = "";
        /**
         * 支店名
         *
         * @generated from field: string branch_name = 2;
         */
        this.branchName = "";
        /**
         * 口座種別
         *
         * @generated from field: string account_type = 3;
         */
        this.accountType = "";
        /**
         * 口座番号
         *
         * @generated from field: string account_number = 4;
         */
        this.accountNumber = "";
        /**
         * 口座名義（カナ）
         *
         * @generated from field: string account_holder_kana = 5;
         */
        this.accountHolderKana = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSBankAccount().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSBankAccount().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSBankAccount().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSBankAccount, a, b);
    }
}
exports.CMSBankAccount = CMSBankAccount;
CMSBankAccount.runtime = protobuf_1.proto3;
CMSBankAccount.typeName = "spwn.order.v1.CMSBankAccount";
CMSBankAccount.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "bank_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "branch_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "account_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "account_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "account_holder_kana", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * CMSではグッズに特化して管理するため、Goods専用のOrderのみを定義する
 *
 * @generated from message spwn.order.v1.CMSOrderGoods
 */
class CMSOrderGoods extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string order_id = 1;
         */
        this.orderId = "";
        /**
         * 注文番号
         *
         * @generated from field: string order_number = 2;
         */
        this.orderNumber = "";
        /**
         * 注文のステータス
         *
         * @generated from field: spwn.order.v1.CMSOrderGoodsStatus status = 3;
         */
        this.status = CMSOrderGoodsStatus.CMS_ORDER_GOODS_STATUS_UNSPECIFIED;
        /**
         * 注文に含まれる商品
         *
         * @generated from field: repeated spwn.order.v1.CMSOrderLineItemGoods line_items = 4;
         */
        this.lineItems = [];
        /**
         * 商品の合計金額
         *
         * @generated from field: int32 total_item_amount = 5;
         */
        this.totalItemAmount = 0;
        /**
         * 配送料
         *
         * @generated from field: int32 total_shipping_fee_amount = 6;
         */
        this.totalShippingFeeAmount = 0;
        /**
         * 合計金額
         *
         * @generated from field: int32 total_payment_amount = 7;
         */
        this.totalPaymentAmount = 0;
        /**
         * 注文日時
         *
         * @generated from field: int64 ordered_at = 8;
         */
        this.orderedAt = protobuf_1.protoInt64.zero;
        /**
         * メモ
         *
         * @generated from field: string comment = 13;
         */
        this.comment = "";
        /**
         * 支払い方法
         *
         * @generated from field: spwn.order.v1.CMSOrderPaymentMethod payment_method = 14;
         */
        this.paymentMethod = CMSOrderPaymentMethod.CMS_ORDER_PAYMENT_METHOD_UNSPECIFIED;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSOrderGoods().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSOrderGoods().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSOrderGoods().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSOrderGoods, a, b);
    }
}
exports.CMSOrderGoods = CMSOrderGoods;
CMSOrderGoods.runtime = protobuf_1.proto3;
CMSOrderGoods.typeName = "spwn.order.v1.CMSOrderGoods";
CMSOrderGoods.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "order_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "status", kind: "enum", T: protobuf_1.proto3.getEnumType(CMSOrderGoodsStatus) },
    { no: 4, name: "line_items", kind: "message", T: CMSOrderLineItemGoods, repeated: true },
    { no: 5, name: "total_item_amount", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "total_shipping_fee_amount", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "total_payment_amount", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "ordered_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 9, name: "paid_at", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 10, name: "shipped_at", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 11, name: "canceled_at", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 12, name: "shipping", kind: "message", T: CMSOrderShipping, opt: true },
    { no: 13, name: "comment", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "payment_method", kind: "enum", T: protobuf_1.proto3.getEnumType(CMSOrderPaymentMethod) },
    { no: 15, name: "destination", kind: "message", T: CMSOrderFulfillmentDestination, opt: true },
]);
/**
 * @generated from message spwn.order.v1.CMSOrderShipping
 */
class CMSOrderShipping extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from oneof spwn.order.v1.CMSOrderShipping.shipping
         */
        this.shipping = { case: undefined };
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSOrderShipping().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSOrderShipping().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSOrderShipping().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSOrderShipping, a, b);
    }
}
exports.CMSOrderShipping = CMSOrderShipping;
CMSOrderShipping.runtime = protobuf_1.proto3;
CMSOrderShipping.typeName = "spwn.order.v1.CMSOrderShipping";
CMSOrderShipping.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "self", kind: "message", T: CMSOrderShippingSelf, oneof: "shipping" },
]);
/**
 * @generated from message spwn.order.v1.CMSOrderShippingSelf
 */
class CMSOrderShippingSelf extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 配送先住所
         *
         * @generated from field: string shipping_address = 2;
         */
        this.shippingAddress = "";
        /**
         * 配送先名
         *
         * @generated from field: string shipping_name = 3;
         */
        this.shippingName = "";
        /**
         * 配送先電話番号
         *
         * @generated from field: string shipping_phone_number = 4;
         */
        this.shippingPhoneNumber = "";
        /**
         * 配送先メールアドレス
         *
         * @generated from field: string shipping_email = 5;
         */
        this.shippingEmail = "";
        /**
         * 配送業者
         *
         * @generated from field: string shipping_carrier_name = 6;
         */
        this.shippingCarrierName = "";
        /**
         * 追跡番号
         *
         * @generated from field: string tracking_number = 7;
         */
        this.trackingNumber = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSOrderShippingSelf().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSOrderShippingSelf().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSOrderShippingSelf().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSOrderShippingSelf, a, b);
    }
}
exports.CMSOrderShippingSelf = CMSOrderShippingSelf;
CMSOrderShippingSelf.runtime = protobuf_1.proto3;
CMSOrderShippingSelf.typeName = "spwn.order.v1.CMSOrderShippingSelf";
CMSOrderShippingSelf.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "shipped_at", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 2, name: "shipping_address", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "shipping_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "shipping_phone_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "shipping_email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "shipping_carrier_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "tracking_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.order.v1.CMSOrderLineItemGoods
 */
class CMSOrderLineItemGoods extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from oneof spwn.order.v1.CMSOrderLineItemGoods.item
         */
        this.item = { case: undefined };
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSOrderLineItemGoods().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSOrderLineItemGoods().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSOrderLineItemGoods().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSOrderLineItemGoods, a, b);
    }
}
exports.CMSOrderLineItemGoods = CMSOrderLineItemGoods;
CMSOrderLineItemGoods.runtime = protobuf_1.proto3;
CMSOrderLineItemGoods.typeName = "spwn.order.v1.CMSOrderLineItemGoods";
CMSOrderLineItemGoods.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "digital", kind: "message", T: CMSOrderLineItemGoodsDigital, oneof: "item" },
    { no: 2, name: "self_shipping_goods", kind: "message", T: CMSOrderLineItemGoodsSelfShipping, oneof: "item" },
]);
/**
 * @generated from message spwn.order.v1.CMSOrderLineItemGoodsDigital
 */
class CMSOrderLineItemGoodsDigital extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string order_line_item_id = 1;
         */
        this.orderLineItemId = "";
        /**
         * @generated from field: string goods_id = 2;
         */
        this.goodsId = "";
        /**
         * @generated from field: string goods_name = 3;
         */
        this.goodsName = "";
        /**
         * @generated from field: string goods_variant_id = 4;
         */
        this.goodsVariantId = "";
        /**
         * @generated from field: string goods_variant_name = 5;
         */
        this.goodsVariantName = "";
        /**
         * @generated from field: string goods_thumbnail = 6;
         */
        this.goodsThumbnail = "";
        /**
         * @generated from field: int32 goods_price = 7;
         */
        this.goodsPrice = 0;
        /**
         * @generated from field: int32 quantity = 8;
         */
        this.quantity = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSOrderLineItemGoodsDigital().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSOrderLineItemGoodsDigital().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSOrderLineItemGoodsDigital().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSOrderLineItemGoodsDigital, a, b);
    }
}
exports.CMSOrderLineItemGoodsDigital = CMSOrderLineItemGoodsDigital;
CMSOrderLineItemGoodsDigital.runtime = protobuf_1.proto3;
CMSOrderLineItemGoodsDigital.typeName = "spwn.order.v1.CMSOrderLineItemGoodsDigital";
CMSOrderLineItemGoodsDigital.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "order_line_item_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "goods_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "goods_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "goods_variant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "goods_variant_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "goods_thumbnail", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "goods_price", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "quantity", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * @generated from message spwn.order.v1.CMSOrderLineItemGoodsSelfShipping
 */
class CMSOrderLineItemGoodsSelfShipping extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string order_line_item_id = 1;
         */
        this.orderLineItemId = "";
        /**
         * @generated from field: string goods_id = 2;
         */
        this.goodsId = "";
        /**
         * @generated from field: string goods_name = 3;
         */
        this.goodsName = "";
        /**
         * @generated from field: string goods_variant_id = 4;
         */
        this.goodsVariantId = "";
        /**
         * @generated from field: string goods_variant_name = 5;
         */
        this.goodsVariantName = "";
        /**
         * @generated from field: string goods_thumbnail = 6;
         */
        this.goodsThumbnail = "";
        /**
         * @generated from field: int32 goods_price = 7;
         */
        this.goodsPrice = 0;
        /**
         * @generated from field: int32 quantity = 8;
         */
        this.quantity = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSOrderLineItemGoodsSelfShipping().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSOrderLineItemGoodsSelfShipping().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSOrderLineItemGoodsSelfShipping().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSOrderLineItemGoodsSelfShipping, a, b);
    }
}
exports.CMSOrderLineItemGoodsSelfShipping = CMSOrderLineItemGoodsSelfShipping;
CMSOrderLineItemGoodsSelfShipping.runtime = protobuf_1.proto3;
CMSOrderLineItemGoodsSelfShipping.typeName = "spwn.order.v1.CMSOrderLineItemGoodsSelfShipping";
CMSOrderLineItemGoodsSelfShipping.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "order_line_item_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "goods_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "goods_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "goods_variant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "goods_variant_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "goods_thumbnail", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "goods_price", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "quantity", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * @generated from message spwn.order.v1.CMSOrderSalesBreakdownItem
 */
class CMSOrderSalesBreakdownItem extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 識別子
         *
         * @generated from field: string item_id = 1;
         */
        this.itemId = "";
        /**
         * 売上項目名（グッズ名、プラン名、バックナンバー名、送料など）
         *
         * @generated from field: string title = 2;
         */
        this.title = "";
        /**
         * 価格
         *
         * @generated from field: int32 price = 3;
         */
        this.price = 0;
        /**
         * 数量
         *
         * @generated from field: int32 quantity = 4;
         */
        this.quantity = 0;
        /**
         * 合計金額
         *
         * @generated from field: int32 total_amount = 5;
         */
        this.totalAmount = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSOrderSalesBreakdownItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSOrderSalesBreakdownItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSOrderSalesBreakdownItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSOrderSalesBreakdownItem, a, b);
    }
}
exports.CMSOrderSalesBreakdownItem = CMSOrderSalesBreakdownItem;
CMSOrderSalesBreakdownItem.runtime = protobuf_1.proto3;
CMSOrderSalesBreakdownItem.typeName = "spwn.order.v1.CMSOrderSalesBreakdownItem";
CMSOrderSalesBreakdownItem.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "item_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "price", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "quantity", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "total_amount", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * @generated from message spwn.order.v1.CMSOrderFulfillmentDestination
 */
class CMSOrderFulfillmentDestination extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string address_id = 1;
         */
        this.addressId = "";
        /**
         * @generated from field: string postal_code = 2;
         */
        this.postalCode = "";
        /**
         * @generated from field: string prefecture = 3;
         */
        this.prefecture = "";
        /**
         * @generated from field: string city = 4;
         */
        this.city = "";
        /**
         * @generated from field: string street_address = 5;
         */
        this.streetAddress = "";
        /**
         * @generated from field: string name = 7;
         */
        this.name = "";
        /**
         * @generated from field: string email = 8;
         */
        this.email = "";
        /**
         * @generated from field: string phone_number = 9;
         */
        this.phoneNumber = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSOrderFulfillmentDestination().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSOrderFulfillmentDestination().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSOrderFulfillmentDestination().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSOrderFulfillmentDestination, a, b);
    }
}
exports.CMSOrderFulfillmentDestination = CMSOrderFulfillmentDestination;
CMSOrderFulfillmentDestination.runtime = protobuf_1.proto3;
CMSOrderFulfillmentDestination.typeName = "spwn.order.v1.CMSOrderFulfillmentDestination";
CMSOrderFulfillmentDestination.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "address_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "postal_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "prefecture", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "city", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "street_address", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "residence", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 7, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "phone_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
//# sourceMappingURL=cms_common_pb.js.map